import { BaseCarouselProps } from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import {
  carouselComponentMap,
  LayoutElementCarousel,
  LayoutElementCarouselProps,
} from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/LayoutElementCarousel";
import { Container } from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Container";
import {
  LayoutElementProvider,
  LayoutElementRendererData,
} from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { LayoutElementRendererProps } from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Props";
import {
  LayoutElementCarouselTitleProps,
  Title,
} from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Title";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import * as React from "react";
import styled from "styled-components";

export const LayoutElementBasedCarousel: React.FC<
  LayoutElementRendererProps &
    LayoutElementCarouselTitleProps &
    BaseCarouselProps & {
      titleClassName?: string;
      elementCarouselClassName?: string;
    }
> = (props) => {
  const { className, elementCarouselClassName, titleClassName, ...rest } =
    props;
  const carouselProps = LayoutElementCarouselProps.build(rest);
  const titleProps = LayoutElementCarouselTitleProps.build(rest);
  const layoutElementProps = LayoutElementRendererData.build(rest);

  return (
    <LayoutElementProvider {...layoutElementProps}>
      <StyledContainer className={className}>
        <LayoutElementCarousel
          className={elementCarouselClassName}
          {...carouselProps}
        />
        {!props.hideTitle ? (
          <Title titleClassName={titleClassName} {...titleProps} />
        ) : null}
      </StyledContainer>
    </LayoutElementProvider>
  );
};

const StyledContainer = styled(Container)`
  display: flex;
  /*  reversed the title and carousel order and fix the ordering using flex column reverse
  Then with sibling selector hide the title if there is no carousel rendered */
  flex-direction: column-reverse;
`;

export const isSupportedCarousel = (
  type: keyof typeof ILayoutElement.Type | undefined
) => carouselComponentMap.has(type);
